import {
  DownloadOutlined,
  ReloadOutlined,
  SaveOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { Button, Flex, Tooltip } from "antd";
import useSaveDataGridData from "components/hooks/dataGrid/useSaveDataGridData";
import useDataGridStore from "stores/dataGridStore";
import { useFetchProductsByFilterStr } from "components/hooks/dataGrid/useDataGridSource";
import useHandleStackUndo from "components/hooks/dataGrid/useHandleStackUndo";
import InformationModalWithButton from "../modals/informationModal";
import { CSVLink } from "react-csv";
import useDataGrid from "components/hooks/dataGrid/useDataGrid";
import { buildDataGridCsvData } from "utility/dataGrid/exportCsv";
import useMetadataStore from "stores/metadataStore";
import { useTranslate } from "@refinedev/core";
import { useMemo } from "react";
import { useProductTypesQuery } from "domains/productType/hooks/useProductTypesQuery";

const ToolBarButtons = () => {
  const {
    updateStack,
    dataSourceIsLoading,
    updateDataSourceIsLoading,
    dataGridfilterStr,
    dataSource,
  } = useDataGridStore();
  const { saveDataGridData } = useSaveDataGridData();
  const { fetchDataGridProducts } = useFetchProductsByFilterStr();
  const { handleUndoStackUpdate } = useHandleStackUndo();
  const { columns } = useDataGrid();
  const { getBrandById } = useMetadataStore();
  const { data: productTypes = [] } = useProductTypesQuery();
  const t = useTranslate();

  const canExport =
    !!dataGridfilterStr &&
    dataSource?.length > 0 &&
    !dataSourceIsLoading &&
    !updateDataSourceIsLoading;

  const csvData = useMemo(
    () =>
      buildDataGridCsvData(dataSource ?? [], columns, {
        getBrandNameById: (id) => getBrandById(id)?.name ?? "",
        getProductTypeNameById: (id) =>
          productTypes.find((productType) => productType.id === id)?.name ?? "",
        getShippingLabelById: (id) => t(String(id)),
      }),
    [dataSource, columns, getBrandById, productTypes, t]
  );

  const exportFileName = `artiklar-export-${new Date()
    .toISOString()
    .slice(0, 10)}.csv`;

  return (
    <Flex
      gap={15}
      justify="center"
      style={{ position: "relative", alignItems: "end" }}
    >
      <Tooltip
        color={"gray"}
        placement="topRight"
        title={"Exportera filtrerade artiklar med synliga kolumner till CSV."}
      >
        <span>
          <CSVLink
            data={csvData}
            filename={exportFileName}
            target="_blank"
            style={{ pointerEvents: canExport ? "auto" : "none" }}
          >
            <Button
              type="default"
              icon={<DownloadOutlined />}
              disabled={!canExport}
            >
              Exportera CSV
            </Button>
          </CSVLink>
        </span>
      </Tooltip>
      <Tooltip
        color={"gray"}
        placement="topRight"
        title={"Ångra din senaste tabellredigering."}
      >
        <Button
          onClick={handleUndoStackUpdate}
          type="default"
          icon={<UndoOutlined />}
          disabled={updateStack.length === 0}
          loading={dataSourceIsLoading}
        >
          Ångra senaste
        </Button>
      </Tooltip>
      <Tooltip
        color={dataGridfilterStr ? "red" : "gray"}
        placement="topRight"
        title={"Alla osparade ändringar försvinner vid omladdning."}
      >
        <Button
          onClick={() => fetchDataGridProducts()}
          type="primary"
          danger
          icon={<ReloadOutlined />}
          disabled={
            dataSourceIsLoading || !dataGridfilterStr || updateDataSourceIsLoading
          }
          loading={dataSourceIsLoading}
        >
          Ladda om
        </Button>
      </Tooltip>

      <Button
        onClick={saveDataGridData}
        disabled={
          updateStack?.length === 0 ||
          updateDataSourceIsLoading ||
          dataSourceIsLoading
        }
        loading={updateDataSourceIsLoading}
        type="primary"
        size="middle"
        icon={<SaveOutlined />}
      >
        Spara
      </Button>
      <InformationModalWithButton />
    </Flex>
  );
};

export default ToolBarButtons;
